import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTGamingHero from "./NFTGamingHero";
import NFTGamingPlatform from "./NFTGamingPlatform";
import ThoroughApproach from "./ThoroughApproach";
import ArcadeGames from "./ArcadeGames";
import UnrealEngine from "./UnrealEngine";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function NFTGaming() {
  return (
    <div>
      <Header />
      <NFTGamingHero />
      <NFTGamingPlatform />
      <ThoroughApproach />
      <UnrealEngine />
      <ArcadeGames />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default NFTGaming;
